// @ts-ignore
import { _ } from "../../../vendor";

const extractLongLat: ({
  longitude,
  latitude,
}: {
  longitude: any;
  latitude: any;
}) => [any, any] = ({ longitude, latitude }: { longitude: any; latitude: any }): [any, any] => [
  longitude,
  latitude,
];

export const routeToGeom: (data: any) => { type: string; coordinates: any } = (
  data: any,
): { type: string; coordinates: any } => ({
  type: "LineString",
  coordinates: _.map(data["route"], extractLongLat),
});

export const endpointToGeom: (data: any) => { type: string; coordinates: any[] } = (
  data: any,
): { type: string; coordinates: any[] } => {
  return {
    type: "Point",
    coordinates: [data["endLon"], data["endLat"]],
  };
};

export const longLatToGeo: (data: any) => { type: string; coordinates: [any, any] } = (
  data: any,
): { type: string; coordinates: [any, any] } => ({
  type: "Point",
  coordinates: extractLongLat(data),
});

export const dataToFeatureFn: (transform: any) => (data: any) => {
  properties: any;
  type: string;
  geometry: any;
} =
  (
    transform: any,
  ): ((data: any) => {
    properties: any;
    type: string;
    geometry: any;
  }) =>
  (
    data: any,
  ): {
    properties: any;
    type: string;
    geometry: any;
  } => ({
    properties: data,
    type: "Feature",
    geometry: transform(data),
  });

export const dataToGeoJSON: (...t: any[]) => (data: any) => {
  type: string;
  crs: { type: string; properties: { name: string } };
  features: any[];
} =
  (
    ...t: any[]
  ): ((data: any) => {
    type: string;
    crs: { type: string; properties: { name: string } };
    features: any[];
  }) =>
  (
    data: any,
  ): {
    type: string;
    crs: { type: string; properties: { name: string } };
    features: any[];
  } => {
    const features: any[] = t
      .map(dataToFeatureFn)
      .map((f) => data.map(f))
      .flat();
    return {
      type: "FeatureCollection",
      crs: {
        type: "name",
        properties: {
          name: "EPSG:4326",
        },
      },
      features,
    };
  };
